import AmexImage from './AmexImage';

export default AmexImage;
